import styled from 'styled-components/macro';
import { Media } from 'app/styles/media-breakpoints';

export const ModalWrapper = styled.div.attrs({
  className: 'common-v4-scrollbar',
})`
  box-sizing: border-box;
  padding: 120px 24px 0;
  position: fixed;
  z-index: 999;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  column-gap: 8px;
  width: 100vw;
  height: 100vh;
  background: rgba(1, 9, 23, 0.3);
  overflow-y: scroll;

  @media (${Media.mobile}) {
    padding: 120px 16px 0;
  }
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: fit-content;
  max-width: 100%;
`;

export const ModalContainer = styled.div<{
  minHeight?: number;
}>`
  position: relative;
  padding: 24px;
  margin-bottom: 120px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  width: 750px;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 'auto')};
  height: fit-content;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 8px 0 rgba(7, 43, 114, 0.04),
    0 12px 28px 0 rgba(0, 32, 51, 0.12);

  @media (${Media.mobile}) {
    padding: 16px;
  }
`;

export const Cross = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #c6c6c6;
  cursor: pointer;
  transition-duration: 200ms;

  &:hover {
    color: #ffffff;
  }

  @media (${Media.mobile}) {
    top: 16px;
    right: 16px;
  }
`;
